/**
 * The route segment of every Transportations tab, and the answer to "which tab owns this
 * experience?" — one enum for both, so the router and the classifier cannot name a tab differently.
 *
 * NOTE: which tab *lists* an experience is a different question from whether a tab has anything to
 * render. The tab bar counts assembled `Flight` and linked `CarRental` objects, neither of which is
 * one experience, so its availability checks must keep reading those collections instead.
 */
export enum TransportationTab {
  Boats = 'boats',
  Buses = 'buses',
  CarRentals = 'car-rentals',
  ConnectingFlights = 'connecting-flights',
  Flights = 'flights',
  Others = 'others',
  Trains = 'trains',
  Transfers = 'transfers',
}
